export default __webpack_public_path__ + "static/media/bar-chart.ab31603e.svg";